/*
================================================================ 
          Copyright (c) 2018-2020 Digitize Things Inc.           
                      All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./input.module.css";

const Input = (props) => {
  return (
    <div className={[classes.mainDiv, props.divClass].join(" ")}>
      {props.label ? (
        <label
          htmlFor={props.id}
          className={[classes.labelClass, props.labelClass].join(" ")}
        >
          {props.label}
        </label>
      ) : null}
      <input
        id={props.id}
        disabled={props.disabled}
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        placeholder={props.placeholder}
        className={[classes.inputClass, props.inputClass].join(" ")}
        onKeyDown={props.onKeyDown}
        onBlur={props.onBlur}
        {...props.inputProps}
      />
    </div>
  );
};

export default Input;
